import {
  DEFAULT_ETH_PRICE,
  WALLET_ACCOUNT_STATUS
} from '../constants/rewardBox'

const WALLET_ERRORS = {
  USER_REJECTED_REQUEST: 'User rejected the request.'
}

const buildTransactionErrorMessage = (message) => {
  return message === WALLET_ERRORS.USER_REJECTED_REQUEST
    ? 'reward-box.rejected-transaction-request'
    : message || 'error.something-went-wrong'
}

const isWalletAccountConnected = ({ status, address }) => {
  return status === WALLET_ACCOUNT_STATUS.CONNECTED && address
}

const getEthPriceForRewardBox = (cryptoExchanges = {}) => {
  const ethPrice = cryptoExchanges.eth?.coinbase
  if (typeof ethPrice === 'number' && ethPrice > 0) {
    const discount = (ethPrice * 5) / 100
    return ethPrice - discount
  }
  return DEFAULT_ETH_PRICE // Fallback if ethPrice is not available
}

const formatTimeForTimer = (time) => {
  const minutes = Math.floor(time / 60)
  const seconds = time % 60
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
}

export {
  WALLET_ERRORS,
  buildTransactionErrorMessage,
  isWalletAccountConnected,
  getEthPriceForRewardBox,
  formatTimeForTimer
}
